import { AppointmentFeatureCard as AppointmentFeature } from './AppointmentFeatureCard'
import { HomeFeatureCard as HomeFeature } from './HomeFeatureCard'
import { SchedulingOpinionsCard as SchedulingOpinions } from './SchedulingOpinionsCard'

export default {
  AppointmentFeature,
  HomeFeature,
  SchedulingOpinions
}
